import { defineStore } from 'pinia'
import { useTasksStore } from '@/stores/tasks'
import { useDocsStore } from '@/stores/docs'
import { useCompanyStore } from '@/stores/company'

export const useFinStore = defineStore('fin', {
  state: () => ({
    hourlyRate: 3500,
    hours: 0,
    currency: 'RUB',
  }),
  getters: {
    tasksList() {
      let tasksStore = useTasksStore()
      return tasksStore.list
    },
    tasksSelectedList() {
      let tasksStore = useTasksStore()
      return tasksStore.selectedItems
    },
    docsList() {
      let docsStore = useDocsStore()
      return docsStore.list
    },
    // Запланировано на текущий спринт
    plan() {
      let sum = 0
      this.tasksList.forEach(item => {
        if (['work', 'done'].indexOf(item.status) >= 0 && !item.guarantee) {
          sum += item.price
        }
      })
      return sum
    },
    // Сумма выделенных задач
    selectedSum() {
      let sum = 0
      this.tasksSelectedList.forEach(item => {
        sum += item.price
      })
      return sum
    },
    // Завершенных задач в текущем спринте
    currentSum() {
      let sum = 0
      this.tasksList.forEach(item => {
        if (item.status === 'done' && !item.guarantee) {
          sum += item.price
        }
      })
      return sum
    },
    // Закрытых задач предыдущих спринтов
    archiveSum() {
      let sum = 0
      this.tasksList.forEach(item => {
        if (item.status === 'closed') {
          sum += item.price
        }
      })
      return sum
    },
    // Клиент должен
    debt() {
      return this.archiveSum + this.currentSum - this.paidSum
    },
    // Баланс
    balance() {
      if (this.debt < 0) {
        return Math.abs(this.debt)
      }

      return 0
    },
    // Сумма оплаченных счетов
    paidSum() {
      let sum = 0
      // Суммируем оплаченные счета
      this.docsList.forEach(item => {
        if (!item.pay || item.status !== '2') {
          return
        }
        sum += Number(item.pay)
      })
      return sum
    },
    // Без акта
    withOutActs() {
      let result = 0
      this.docsList.forEach(item => {
        if (item.pay && item.status === '2' && !item.noAct) {
          result += Number(item.pay)
        }
        if (item.act && item.status === '4') {
          result -= item.act
        }
      })
      return result
    }
  },
  actions: {
    setCompany() {
      let companyStore = useCompanyStore()
      this.hourlyRate = companyStore.hourlyRate
      this.hours = companyStore.hours
      this.currency = companyStore.sysObject.currency
    }
  },
})
